/*
 * @Author: Teemo Ding
 * @Date: 2022-04-15 16:02:50
 * @LastEditTime: 2022-06-16 14:15:08
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsList/index.tsx
 */
import { NoDataPage } from '@/src/components';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import { MenuItemType } from '@/src/components/BulkEditor/BulkEditor';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { deleteReport, reportList } from '@/src/request/analytics/report';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { getParameter } from '@/src/tools/helper';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { message } from 'antd';
import React, { memo, useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { NEW, defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { randomNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { ICategory } from 'src/types/common/report';
import { breadcrumbData, columns, tabsConfig } from './config';
import css from './css.module.less';

const addButtonMenu = ({ getI18n }) => [
  {
    name: getI18n('reports.reportlist.orderReport'),
    type: ICategory.Order,
  },
  {
    name: getI18n('general.subscriptionBuy'),
    type: ICategory.SubscriptionBuy,
  },
  {
    name: getI18n('reports.reportlist.paymentReport'),
    type: ICategory.Payment,
  },
  {
    name: getI18n('reports.reportlist.promotionReport'),
    type: ICategory.Promotion,
  },
  {
    name: getI18n('reports.reportlist.parcelReport'),
    type: ICategory.Parcel,
  },
  {
    name: getI18n('reports.reportlist.customerReport'),
    type: ICategory.Customer,
  },
  {
    name: getI18n('reports.reportlist.productsReport'),
    type: ICategory.Product,
  },
  {
    name: getI18n('reports.reportlist.inventoryReport'),
    type: ICategory.Inventory,
  },
  {
    name: getI18n('reports.reportlist.giftCard&StoreCreditReport'),
    type: ICategory.GiftCard,
  },
  {
    name: getI18n('reports.reportlist.pageReport'),
    type: ICategory.Page,
  },
  {
    name: getI18n('reports.reportlist.orderLineItemsReport'),
    type: ICategory.OrderLineItemsReport,
  },
];

const permissions = () => {
  const view_report_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.view_report_listing_page,
      }),
    ],
  });
  const add_report = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.add_edit_report,
      }),
    ],
  });
  const view_report = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.view_report_details_page,
      }),
    ],
  });
  const delete_report = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Analytics,
        subCategory: EnumSubCategory.AnalyticsReports,
        operation: EnumOperation.delete_report,
      }),
    ],
  });
  return {
    view_report_listing_page,
    view_report,
    delete_report,
    add_report,
  };
};
const ReportsList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_report_listing_page, add_report, delete_report, view_report } =
    permissions();
  const history = useHistory();
  const activeTab = getParameter('activeTab');
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [reportingCurrency, setReportingCurrency] = useState('');
  const [timezoneInGMT, setTimezoneInGMT] = useState('');
  const [noProducts, setNoProducts] = useState(false);
  const [sortBy, setSortBy] = useState<any>({});
  const [tabsActive, setTabsActive] = useState(activeTab || ICategory.Null);
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { clearSearchState, queryProps, search } = useQueries([], []);

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(orders);

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    setTabsActive(activeKey);
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    const status =
      tabsActive !== ICategory.Null ? { category: tabsActive } : {};
    const _data = {
      ...data,
      ...status,
      ...(Object.keys(sortBy).length ? { sortBy } : {}),
    };
    reportList(current * pageSize, pageSize, _data).then((res) => {
      const { totalCount } = res;
      setTotal(totalCount);
      const orders = res.results.map((i) => {
        return {
          ...i,
          key: randomNumber(),
        };
      });
      setOrders(orders);
      setLoading(false);
    });
  };

  const buttonMenu = [
    //Bulk Edit
    {
      key: 1,
      value: getI18n('general.delete'),
      type: MenuItemType.Error,
      function: () => handleDeleteFun(selectedRowKeys),
      disabled: !delete_report,
    },
  ];

  React.useEffect(() => {
    const status =
      tabsActive !== ICategory.Null ? { category: tabsActive } : {};
    if (view_report_listing_page) {
      reportList(current * pageSize, pageSize, { ...status }).then((res) => {
        const {
          totalCount = 0,
          results = [],
          extraInfo: { timeZone = '' } = {},
        } = res;
        setReportingCurrency(reportingCurrency);
        setTimezoneInGMT(timeZone);
        setTotal(totalCount);
        setOrders(results);
        if (totalCount <= 0 && !tabsActive) {
          setNoProducts(false);
        } else {
          setNoProducts(true);
        }
      });
    } else {
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (view_report_listing_page) {
      getProduct(() => void 0);
    }
  }, [tabsActive, current]);

  useAfterDidMountEffect(() => {
    if (view_report_listing_page) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy]);

  const handleGoToReportDetail = (type, uuid?) => {
    history.push(`/report/${type}/${uuid || NEW}`);
  };

  const addButtonOverlay = (
    <div className={css.addButtonOverlay}>
      <div className={css.addButtonTitle}>
        {getI18n('reports.reportlist.createReport')}
      </div>
      <div className={css.addButtonAll}>
        {addButtonMenu({ getI18n }).map((list, index) => (
          <div
            key={index}
            className={css.addButtonList}
            onClick={() => handleGoToReportDetail(list.type)}>
            <p className={css.addButtonLinkTitle}>{list.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
  const addFun = () => {
    console.log('Add');
  };
  const handleDeleteFun = (uuids) => {
    deleteReport({ uuids }).then(() => {
      message.success(getI18n('reports.reportdetailcommon.delsucc'));
      getProduct(() => void 0);
    });
  };
  const pageLayoutProps = {
    title: getI18n('reports.reportdetailcommon.reports'),
    addButtonOverlay,
    activeKey: tabsActive,
    tabsConfig: tabsConfig({ getI18n }),
    addText: getI18n('reports.reportlist.createReport'),
    addFun,
    disableAdd: !add_report,
  };
  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}></Breadcrumb>
      {!noProducts ? (
        <NoDataPage
          title={getI18n('reports.reportlist.addthefirstreporttoyourstore')}
          introduce={getI18n(
            'reports.reportlist.addandmanagereportsinyourstore',
          )}
          addButtonOverlay={addButtonOverlay}
          buttonTitle={getI18n('reports.reportlist.createReport')}
          disabled={!add_report}
        />
      ) : (
        <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
          <GlobalTable
            id='reportList'
            queryProps={queryProps}
            dataSource={orders}
            columns={columns(
              timezoneInGMT,
              handleDeleteFun,
              handleGoToReportDetail,
              !view_report,
              !delete_report,
              { getI18n },
            )}
            rowKey='uuid'
            pagination={paginationProps}
            current={current}
            setCurrent={setCurrent}
            pageSize={pageSize}
            setPageSize={setPageSize}
            buttonMenu={buttonMenu}
            total={total}
            holdHeader
            rowSelection={rowSelection}
            totalText={getI18n('reports.reportlist.displayingproducts')}
            selectedRowKeys={selectedRowKeys}
            hidePagination={total == 0}
            // onRow={(record) => ({
            //   onClick: () => history.push(`/communication/${record.uuid}`),
            // })}
            onChange={(_, s, sort) => {
              const ascent = sort.order == 'ascend' ? true : false;
              setSortBy({ field: sort.field, ascent });
            }}
            loading={loading}
          />
        </ListPageLayout>
      )}
    </React.Fragment>
  );
};

export default memo(ReportsList);
